import { fetcher } from './httpMethods'

const getIPData = async () => {
  return await fetcher({
    url: `https://ipapi.co/json/?key=${process.env.NEXT_PUBLIC_IPAPI_KEY}`
  })
}

const getExchangeData = async () => {
  return await fetcher({
    url: `https://cdn.jsdelivr.net/npm/@fawazahmed0/currency-api@latest/v1/currencies/usd.json`
  })
}

const getLocationExchangeRate = async () => {
  const [ipData, exchangeData] = await Promise.all([
    getIPData(),
    getExchangeData()
  ])

  return {
    currency: ipData.currency,
    exchangeRate: exchangeData.usd[ipData.currency.toLowerCase()]
  }
}

const displayExchangedPrice = ({
  value,
  exchangeRate,
  currency,
  loaded
}: {
  value: number
  exchangeRate: number
  currency: string
  loaded: boolean
}) => {
  if (!loaded) {
    return '-'
  }

  return (
    new Intl.NumberFormat('en-US').format(Math.round(value * exchangeRate)) +
    currency
  )
}

export { getLocationExchangeRate, displayExchangedPrice }
